import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from "@mui/material"
import moment, { Moment } from "moment"
import { useState } from "react"
import PaperDraggable from "../../../../../../../../components/PaperDraggable"
import BasicDatePicker from "../../../../../../../../components/BasicDatePicker"
import MultipleDatePicker from "../../../../../../../../components/MultipleDataPicker"
import { TFiltrosDetalheFechamento } from "../../../../../../../../types/api/financeiro/detalhar-fechamentos-conta-corrente"
import { usePermission } from "../../../../../../../../components/PermissionGuard"

export default function ConfiguracoesCabecalho({
    open,
    filtrosParams,
    handleUpdateFiltros,
    onClose,
    handleExcluir
}: TConfiguracoesCabecalhoProps) {

    const excluirFechamento = usePermission('financeiro.cco-excluir-fechamento')

    const valoresDefault: TConfiguracoesCabecalho = {
        nome: filtrosParams.nome,
        data_fechamento: filtrosParams.data_fechamento,
        titulos_pagar_vencimento: filtrosParams.titulos_pagar_vencimento,
        titulos_receber_vencimento: filtrosParams.titulos_receber_vencimento
    }
    const [internFilters, setInternFilters] = useState<TConfiguracoesCabecalho>(valoresDefault)

    const handleChange = (key: keyof TConfiguracoesCabecalho, value: any) => {
        setInternFilters({ ...internFilters, [key]: value })
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Editar fechamento
            </DialogTitle>
            <DialogContent>

                <Grid container spacing={2}>
                    <Grid size={{xs: 12}} mt={1}>
                        <TextField
                            fullWidth
                            label="Nome do fechamento"
                            value={internFilters.nome}
                            onChange={(e) => handleChange('nome', e.target.value)} />
                    </Grid>

                    <Grid size={{xs: 12}} mt={1}>
                        <BasicDatePicker
                            label="Fechamento"
                            value={internFilters.data_fechamento ? moment(internFilters.data_fechamento) : null}
                            formatString="DD/MM/YYYY"
                            onChange={(data: Moment | null) => { handleChange('data_fechamento', data?.format('YYYY-MM-DD')) }}
                        />
                    </Grid>

                    <Grid size={{xs: 12}}>
                        <Typography fontWeight={'bold'} variant="body1">Vencimento dos títulos a serem gerados:</Typography>
                    </Grid>

                    <Grid size={{xs: 12}} mt={1}>
                        <MultipleDatePicker
                            blockPastDates
                            label="Vencimento títulos a pagar"
                            value={internFilters.titulos_pagar_vencimento ?
                                internFilters.titulos_pagar_vencimento.map(date => moment(date, 'YYYY-MM-DD')) :
                                []
                            }
                            formatString="DD/MM/YYYY"
                            onChange={(data: Moment[] | null) => { handleChange('titulos_pagar_vencimento', data?.map(item => item.format('YYYY-MM-DD'))) }}
                        />

                    </Grid>
                    <Grid size={{xs: 12}} mt={1}>
                        <MultipleDatePicker
                            blockPastDates
                            label="Vencimento títulos a receber"
                            value={internFilters.titulos_receber_vencimento ?
                                internFilters.titulos_receber_vencimento.map(date => moment(date, 'YYYY-MM-DD')) :
                                []
                            }
                            formatString="DD/MM/YYYY"
                            onChange={(data: Moment[] | null) => { handleChange('titulos_receber_vencimento', data?.map(item => item.format('YYYY-MM-DD'))) }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Box display={'flex'} justifyContent={'space-between'} width={'100%'} mx={2}>
                    <Box>
                        {
                            excluirFechamento &&
                            <Button
                                variant="text"
                                color="error"
                                onClick={handleExcluir}
                                disabled={!internFilters.nome}
                            >
                                Excluir
                            </Button>
                        }
                    </Box>
                    <Box display={'flex'} gap={2}>
                        <Button variant="outlined" onClick={onClose}>
                            Fechar
                        </Button>
                        <Button variant="contained" onClick={() => handleUpdateFiltros(internFilters)}>
                            Salvar
                        </Button>
                    </Box>
                </Box>
            </DialogActions>
        </Dialog>
    )
}

interface TConfiguracoesCabecalhoProps {
    open: boolean
    filtrosParams: TFiltrosDetalheFechamento
    handleUpdateFiltros: (value: TConfiguracoesCabecalho) => void
    onClose: () => void
    handleExcluir: () => void
}

export type TConfiguracoesCabecalho = {
    nome: string
    data_fechamento: string | null
    titulos_pagar_vencimento: string[] | null
    titulos_receber_vencimento: string[] | null
}
